import React from 'lib/react';
import { EVGrid, EVSkeleton } from 'lib/components';

function ExportDataLoader() {
  const newArr = (length) => Array(length).fill().map((_, i) => i);
  return (
    <EVGrid container style={{ gap: '16px', padding: '16px' }}>
      {newArr(8).map((i) => (
        <EVGrid key={`loader-column-${i}`} container direction="column" style={{ gap: '16px', flex: 1 }}>
          {newArr(17).map((j) => (<EVSkeleton key={`loader-${i}-${j}`} style={{ height: '24px' }} animation="wave" variant="rect" />))}
        </EVGrid>
      ))}
    </EVGrid>
  );
}

export default ExportDataLoader;
